import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { OpenService } from './open.service';
import { Shelf } from '@app-model/shelf';
import _, { flatMap } from 'lodash';
import { tap } from 'rxjs/operators';
import { FastQuoteService } from './fast-quote.service';
import { PageControl } from '@app-model/page-control';
import { VehicleFilter } from './open.service';

@Injectable({
  providedIn: 'root'
})
export class ShelfService {

  constructor(
    private readonly openService: OpenService,
    private readonly fastQuoteService: FastQuoteService
  ) {

  }

  private shelves = new Map<String, any>();
  private expirationTimestamp: number = 0;

  public searchShelfItems(shelf: Shelf): Observable<any> {
    this.checkAndClearShelvesIfExpired();

    if (this.shelves.has(shelf.id) && this.expirationTimestamp > Date.now()) {
      return of(this.shelves.get(shelf.id));
    } else {
      return this.searchByShelfType(shelf);
    }
  }

  public clearShelfCache(id?: string): void {
    if (id) {
      this.shelves.delete(id);
    } else {
      this.shelves.clear();
      this.expirationTimestamp = 0;
    }
  }

  private checkAndClearShelvesIfExpired(): void {
    if(this.expirationTimestamp < Date.now()){
      this.shelves.clear();
      this.expirationTimestamp = 0;
    }
  }

  private searchByShelfType(shelf: Shelf): Observable<any> {
    const prepareFilter = (filter: VehicleFilter) => {
      if (!filter) {
        return;
      }
      if (!filter.pageControl) {
        filter.pageControl = new PageControl();
        filter.pageControl.page = 0;
        filter.pageControl.pageSize = 16;
      }
    };

    if (shelf.type == 'VEHICLE') {
      prepareFilter(shelf.vehicleFilter);
      return this.fetchAndStoreShelf(
        shelf.id,
        this.openService.searchAuctions(shelf.vehicleFilter)
      );
    } else if (shelf.type == 'FAST_QUOTE') {
      prepareFilter(shelf.fastQuoteFilter);
      return this.fetchAndStoreShelf(
        shelf.id,
        this.fastQuoteService.searchFastQuotes(shelf.fastQuoteFilter)
      );
    } else {
      return of(null);
    }
  }

  private fetchAndStoreShelf(id: string, observable: Observable<any>): Observable<any> {
    return observable.pipe(
      tap((response) => {
        this.shelves.set(id, response);
        if(!this.expirationTimestamp){
          this.expirationTimestamp = Date.now() + ((60 * 1000) * 10);
        }
      })
    );
  }
}
